import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../../components/CustomAlert";
import CustomDialog from "../../../components/CustomDialog";
import DayJsUtils from "@date-io/dayjs";
import { Autocomplete as FormikAutocomplete } from "formik-material-ui-lab";
import { TextField as FormikTextField } from "formik-material-ui";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createShipconfigService } from "../../../../services/shipConfigService";
import dayjs from "dayjs";
import { fetchSailorSpecialization } from "../../../../services/sailorSpecializationService";
import { fetchSectors } from "../../../../services/sectorService";
import localeEl from "dayjs/locale/el";
import localeEn from "dayjs/locale/en";
import useLocale from "../../../../hooks/useLocale";
import GovGrModal from "../../../../components/GovGrModal";
import GovGrSelectBox from "../../../../components/GovGrSelectBox";
import GovGrTextField from "../../../../components/GovGrTextField";
import GovGrButton from "../../../../components/GovGrButton";

function CreateDialog({ open, close, refreshTable, ship_record_hd_id }) {
  const [error, setError] = useState("");
  const { t, locale } = useLocale();
  dayjs().locale(locale === "el-GR" ? localeEl : localeEn);

  // Mutation for creating data
  const { mutate } = useMutation(createShipconfigService, {
    onSuccess: (data) => {
      refreshTable();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  // Initial values
  const initialValues = {
    ship_record_hd_id,
    sector: null,
    specialty: null,
    no: null,
  };

  const shipRecordHdFormValidation = Yup.object().shape({
    specialty: Yup.object().required(t("Field is required")).nullable(),
    sector: Yup.object().required(t("Field is required")).nullable(),
    no: Yup.number()
      .typeError("Number required")
      .required(t("Field is required"))
      .nullable(),
  });

  const handleCreateItem = (values) => {
    const valuesToSend = {
      ship_record_hd_id: values.ship_record_hd_id,
      sector_id: values.sector?.id,
      specialty_id: values.specialty?.id,
      no: values?.no,
    };
    mutate({ items: JSON.stringify([valuesToSend]) });
  };

  const {
    data: specialties,
    isSpecialtyError,
    isSpecialtyLoading,
    refetchSpecialty,
  } = useQuery("sailorSpecialization", fetchSailorSpecialization);

  const {
    data: sectors,
    isSectorsError,
    isSectorsLoading,
    refetchSectors,
  } = useQuery("sectors", fetchSectors);

  console.log(specialties);
  return (
    <MuiPickersUtilsProvider
      locale={locale === "el-GR" ? localeEl : localeEn}
      utils={DayJsUtils}
    >
      <GovGrModal customContent="true" open={open} onClose={close}>
        <div className="govgr-heading-l m-0">
          {t("Insert new Configuration")}
        </div>

        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />
        <Formik
          initialValues={initialValues}
          validationSchema={shipRecordHdFormValidation}
          onSubmit={(values, { setSubmitting }) => {
            handleCreateItem(values);
            setSubmitting(false);
          }}
        >
          {({ submitForm, touched, errors }) => (
            <Form>
              <DialogContent>
                <GovGrSelectBox
                  name="specialty"
                  options={specialties || []}
                  optionLabel="name"
                  label={t("Specialization")}
                />
                <GovGrSelectBox
                  name="sector"
                  options={sectors || []}
                  optionLabel="dscr"
                  label={t("Sector")}
                />
                <GovGrTextField name="no" label={t("Count")} />
              </DialogContent>
              <DialogActions>
                <GovGrButton
                  onClick={submitForm}
                  variant="primary"
                  buttonText={t("Submit")}
                />
                <GovGrButton
                  onClick={close}
                  variant="secondary"
                  buttonText={t("Cancel")}
                />
              </DialogActions>
            </Form>
          )}
        </Formik>
      </GovGrModal>
    </MuiPickersUtilsProvider>
  );
}

export default CreateDialog;
